import React from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

import Breadcrumbs from '../../../layout/components/Breadcrumbs';
import PermissionsGate from '../../../components/PermissionsGate/PermissionsGate';
import { permissions } from '../../../common/permissionGroup';
import Button from '../../../components/Button/Button';
import useQueryParams from '../../../hooks/useQueryParams';
import { IconLoading } from '../../../assets/icon';

const subheaderClassName = 'flex items-center border-t border-[#eff2f5] dark:border-[#1b263b] px-[25px] h-full';
const breadcrumbsClassName = 'py-[5px]';
const dividerClassName = 'w-[1px] bg-[#eff2f5] dark:bg-[#1b263b] mx-[17px]';
const buttonClassName = 'px-[13px] py-[8px] mr-[5px]';

const ArticlesCreateEditSubheader = ({ isValid, onSave, loading }) => {
  const navigate = useNavigate();
  const [{ id }] = useQueryParams();
  const breadcrumbs = {
    pageTitle: 'Articles',
    history: [
      {
        title: 'Home',
        onClick: () => navigate('/')
      },
      {
        title: 'Articles',
        onClick: () => navigate('/articles')
      },
      {
        title: 'Edit'
      }
    ]
  };

  return (
    <div className={subheaderClassName}>
      <div className="flex-1">
        <div className="flex flex-row items-center">
          <Breadcrumbs breadcrumbs={breadcrumbs} containerStyle={breadcrumbsClassName} />
        </div>
      </div>
      <div className="flex flex-row justify-end">
        <div className={dividerClassName} />
        <PermissionsGate can={permissions.ARTICLES_CREATE}>
          <Button
            text={`${id ? 'Update' : 'Create'}`}
            onClick={onSave}
            containerStyle={buttonClassName}
            disabled={!isValid}
            icon={loading ? <IconLoading className="spin" /> : null}
          />
        </PermissionsGate>
      </div>
    </div>
  );
};

ArticlesCreateEditSubheader.propTypes = {
  onSave: PropTypes.func,
  isValid: PropTypes.bool,
  loading: PropTypes.bool,
};

ArticlesCreateEditSubheader.defaultProps = {
  onSave: () => {},
  isValid: false,
  loading: false
};

export default ArticlesCreateEditSubheader;
